import { useQuery } from '@apollo/client';
import { graphql } from 'gql.tada';
import { SidebarFragment } from '~/components/Sidebar/SidebarFragment';
import { SchoolSelectorFragment } from '~/components/SchoolSelector/SchoolSelectorFragment';

export const AppQuery = graphql.persisted(
  "AppQuery",
  graphql(`
    query AppQuery($schoolId: ID!) {
      currentUser {
        ...SchoolSelectorFragment
      }
      school(id: $schoolId) {
        ...SidebarFragment
      }
    }
  `, [SidebarFragment, SchoolSelectorFragment])
);

export function useAppQuery(schoolId: string | null, skip: boolean) {
  return useQuery(AppQuery, {
    variables: { schoolId: schoolId! },
    skip: !schoolId || skip,
  });
}
